import * as React from 'react';
import styled from 'styled-components';
import { AttachmentTag } from '../AttachmentTag';
import { InputFile } from '../InputFile';
import { IUploadAttachmentProps, IBFile } from './UploadAttachment.types';
import { onFileChange, onTagClick } from './UploadAttachment.logic';
import { getAssetPath } from '../../util/images';
import { SvgImage } from '../SvgImage';

const AtachementInfoIcon = styled(SvgImage)`
  svg {
    path {
      fill: ${({ theme }) => theme.colors.primary};
    }

    circle {
      stroke: ${({ theme }) => theme.colors.primary};
    }
  }
`;

const AtachementTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  user-select: none;
`;

const AtachementTitle = styled.span`
  margin-right: 100px;
`;

const UploadAttachment: React.FC<IUploadAttachmentProps> = (
  props: IUploadAttachmentProps
) => {
  const {
    onChange,
    value,
    type,
    children,
    title,
    className,
    onFileDownload,
    accept,
    disabled,
    tooltipInfo,
    onDelete
  } = props;
  const handleOnChange = (e: File | File[]) =>
    onFileChange(e, value, type, onChange);
  return (
    <div className={className}>
      {title && (
        <AtachementTitleWrapper>
          <AtachementTitle>{title}</AtachementTitle>
          {tooltipInfo && (
            <div data-for="modalTooltip" data-tip={tooltipInfo}>
              <AtachementInfoIcon
                inAssetsPath={getAssetPath('icons/info.svg')}
              />
            </div>
          )}
        </AtachementTitleWrapper>
      )}
      <div className="d-flex w-100">
        <InputFile
          className="d-inline-block"
          type={type}
          onChange={handleOnChange}
          accept={accept}
          disabled={disabled}
        >
          {children ?? 'Upload document'}
        </InputFile>
        <div className="d-inline-block ">
          {value &&
            (type === 'single' ? (
              <AttachmentTag
                testId="single-attachment-tag"
                disallowRemove={!(value as IBFile).file}
                name={(value as IBFile).fileName}
                onDelete={() => onChange(undefined)}
                onClick={() => onTagClick(value as IBFile, onFileDownload)}
              />
            ) : (
              (value as IBFile[]).map(tag => (
                <AttachmentTag
                  testId="multi-attachment-tag"
                  disallowRemove={disabled}
                  key={tag.fileName}
                  onClick={() => onTagClick(tag, onFileDownload)}
                  name={tag.fileName}
                  onDelete={() => {
                    if (onDelete) {
                      onDelete(tag);
                    }
                  }}
                />
              ))
            ))}
        </div>
      </div>
    </div>
  );
};

export default UploadAttachment;
